import LOCALE from './locale';

const formatPercent = (number: number, maximumFractionDigits = 3): string =>
  number.toLocaleString(LOCALE, {
    maximumFractionDigits,
    style: 'percent',
  });

export default formatPercent;
